import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Bnc from '../Bnc.jpg';
import MonCash from '../MonCash.jpg';
import LajanCash from '../LajanCash.png';
import Button from 'react-bootstrap/Button';
import Mode_paiement from './Mode_paiement';
import { FaEdit } from 'react-icons/fa';

const InfoTransaction = ({
  setCurrentform,
  currentform,
  infoPh,
  setInfoPh,
  candidatSelectionne,
  setCandidatSelectionne,
  methode_paiement,
  setMethode_paiement,
}) => {
  const [date_trx, setDate_trx] = useState('');
  const [id_trx, setId_trx] = useState('');
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center mb-1'>Info. Transaction</h2>
            <h3 className='bg-red text-center mb-1'>
              Module en cours de developpement
            </h3>
          </div>
          <div className='card-body'>
            <div className='row d-flex justify-content-center'>
              <Form>
                <div className='container'>
                  <div>
                    {methode_paiement == '0' && (
                      <h2 className='text-center'>
                        Type de Paiement {'  '} BNC{' '}
                        <FaEdit
                          size={30}
                          onClick={(e) => setCurrentform(currentform - 1)}
                        />
                      </h2>
                    )}
                    {methode_paiement == '1' && (
                      <h2 className='text-center'>
                        Type de Paiement {'  '} LaJanCach{' '}
                        <FaEdit
                          size={30}
                          onClick={(e) => setCurrentform(currentform - 1)}
                        />
                      </h2>
                    )}
                    {methode_paiement == '2' && (
                      <h2 className='text-center'>
                        Type de Paiement {'  '} MonCash{' '}
                        <FaEdit
                          size={30}
                          onClick={(e) => setCurrentform(currentform - 1)}
                        />
                      </h2>
                    )}
                  </div>
                  <hr />
                  <Form.Row>
                    <div className='col-sm-10 offset-col-sm-1 col-md-6 col-lg-6'>
                      <div className='form-group'>
                        <label htmlFor='exampleInputEmail1'>
                          Date Transaction
                        </label>
                        <input
                          type='date'
                          className='form-control'
                          id='exampleInputEmail1'
                          aria-describedby='emailHelp'
                          placeholder='Date Transaction'
                          name='date_trx'
                          value={date_trx}
                          onChange={(e) => setDate_trx(e.target.value)}
                          onBlur={(e) => setDate_trx(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='col-sm-10 offset-col-sm-1 col-md-6 col-lg-6'>
                      <div className='form-group'>
                        <label htmlFor='exampleInputEmail1'>
                          ID Transaction
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          id='exampleInputTrx_id'
                          placeholder='No  Transaction'
                          name='id_trx'
                          value={id_trx}
                          onChange={(e) => setId_trx(e.target.value)}
                          onBlur={(e) => setId_trx(e.target.value)}
                        />
                      </div>
                    </div>
                    <Button
                      className='btn-block'
                      style={{ marginTop: '20px', marginBottom: '10px' }}
                      variant='primary'
                      onClick={(e) => setCurrentform(currentform + 1)}
                    >
                      Continuer
                    </Button>
                  </Form.Row>
                </div>
              </Form>
            </div>
          </div>

          <div className='card-footer'>
            {/*          
            <div className='d-flex justify-content-between'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Etape precedente
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform + 1)}
              >
                Etape Suivante
              </button>
            </div>
          */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoTransaction;
